module.exports = __webpack_public_path__ + "static/media/creativ5.88698d63.jpg";